module.exports = __webpack_public_path__ + "img/eg.d9af197.webp";